import { z } from 'zod';
import { localeCodeSchema } from './common';

export const updateProfileSchema = z.object({
  displayName: z.string().min(1).max(40).optional(),
  bio: z.string().max(500).optional(),
  avatarPath: z.string().max(500).nullable().optional(),
  locale: localeCodeSchema.optional(),
});
export type UpdateProfileInput = z.infer<typeof updateProfileSchema>;

export const uploadSignSchema = z.object({
  purpose: z.enum(['avatar', 'request', 'chat', 'product']),
  ext: z.enum(['webp', 'jpg', 'jpeg', 'png']).default('webp'),
  /** purpose=chat일 때 필수 — 방 멤버십 검증 */
  roomId: z.string().uuid().optional(),
});
export type UploadSignInput = z.infer<typeof uploadSignSchema>;
